<template>
  <PanelPage ref="useAlerts" :loading-overlay="loadingOverlay" md="12">
    <v-row class="justify-center">
      <v-col cols="12" md="8">
        <v-card class="mb-6">
          <v-card-title>Add/Check PMS Pending Request</v-card-title>
          <v-card-title>
            <v-autocomplete
              label="PMS"
              :items="pmses"
              v-model="pmsId"
              item-title="visual_name"
              item-value="id"
            />
          </v-card-title>
          <v-divider/>
          <v-form v-show="pmsId" @submit.prevent="submit">
            <v-card-text>
              <v-text-field
                v-model="form.parkadmin_username.value.value"
                :error-messages="form.parkadmin_username.errorMessage.value"
                label="Parkadmin Username"
              />
              <v-text-field
                v-model="form.token.value.value"
                :error-messages="form.token.errorMessage.value"
                label="TOKEN"
              />
              <v-text-field
                v-model="form.label.value.value"
                :error-messages="form.label.errorMessage.value"
                label="Label/Alias"
              />
              <v-autocomplete
                label="Linked Parks"
                :items="parks"
                multiple
                chips
                v-model="form.linked_parks.value.value"
                :error-messages="form.linked_parks.errorMessage.value"
                item-title="name"
                item-value="id"
              />
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn type="reset">Reset</v-btn>
              <v-btn type="submit">Submit</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col cols="12" md="12">
        <v-card v-show="pmsId">
          <v-container>
            <v-row>
              <v-col cols="2" v-for="pmspr in pmsPRs" :key="pmspr['id']">
                <v-card class="mb-4 text-center fill-height d-flex align-center" variant="tonal">
                  <v-card-text>
                    <b>id:</b> {{ pmspr['id'] }}<br/>
                    <b>label:</b> {{ pmspr['label'] }}<br/>
                    <b>token:</b> {{ pmspr['registration_token'] }}<br/>
                    <b>parks:</b>
                    <template v-for="p_id in pmspr['authorized_parks']" :key="p_id">
                      <br/>{{ parks.find((el) => el['id'] === p_id)['name'] }}
                    </template>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </PanelPage>
</template>

<script setup>
import PanelPage from "../components/PanelPage.vue";
import { ref, onMounted, watch } from "vue";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
import { getFormFromSchema } from "../utils.js";
import { createPMSPendingReq, fetchPMSes, fetchPMSPendingReqs } from "../remote/pms.js";
import { fetchParks } from "../remote/park.js";

// State
const useAlerts = ref(null);
const loadingOverlay = ref(false);
const pmses = ref([]);
const pmsId = ref(null);
const pmsPRs = ref([]);
const parks = ref([]);

// Form
// noinspection JSCheckFunctionSignatures
const schema = yup.object({
  parkadmin_username: yup.string().required(),
  token: yup.string().required(),
  label: yup.string().required(),
  linked_parks: yup.array(),
});

const { handleSubmit } = useForm({
  validationSchema: schema
});

const form = getFormFromSchema(schema);

// noinspection JSValidateTypes
const submit = handleSubmit(async (values) => {
  let payload = {
    label: values['label'],
    registration_token: values['token'],
    authorized_parks: values['linked_parks']
  };
  console.log(payload);
  loadingOverlay.value = true;
  // Create PMS Pending Request
  try {
    await createPMSPendingReq(useAlerts, payload, pmsId.value);
  } catch (e) {
    useAlerts.value.errorAlert('Error during PMS PR creation', e.toString());
  } finally {
    await retrievePMSPendingReqs(pmsId.value);
    loadingOverlay.value = false;
  }
});

async function retrieveInitialInfo() {
  loadingOverlay.value = true;
  try {
    [pmses.value, parks.value] = await Promise.all([fetchPMSes(), fetchParks()]);
  } catch (e) {
    useAlerts.value.errorAlert('Impossible to load initial infos', e.toString());
  } finally {
    loadingOverlay.value = false;
  }
}

async function retrievePMSPendingReqs(pms_id) {
  loadingOverlay.value = true;
  try {
    pmsPRs.value = await fetchPMSPendingReqs(pms_id);
  } catch (e) {
    useAlerts.value.errorAlert('Impossible to load PMS Pending Requests', e.toString());
  } finally {
    loadingOverlay.value = false;
  }
}

watch(pmsId, async (newValue) => {
  if (newValue !== null) {
    loadingOverlay.value = true;
    await retrievePMSPendingReqs(newValue);
    loadingOverlay.value = false;
  }
});

onMounted(retrieveInitialInfo);

</script>

<style scoped>

</style>
